import client from "../apolloClient";
import { AUTH_QUERIES } from "../queries/auth.queries";

interface SendOTPResponse {
    sendOTP: {
      success: boolean;
      message: string;
      transactionId: string;
    };
  }

  interface ResendOTPResponse {
    resendOTP: {
      success: boolean;
      message: string;
      transactionId: string;
    };
  }

  interface VerifyPhoneOTPResponse {
    verifyPhoneOTP: {
      success: boolean;
      message: string;
      token?: string;
    };
  }

  export const authService = {
    async sendOTP(mobileNumber: string, entityType: string, transactionType: string): Promise<SendOTPResponse> {
        try{
          const { data, errors } = await client.mutate({
            mutation: AUTH_QUERIES.SEND_OTP,
            variables: { phone: mobileNumber, entityType, transactionType },
        });
    
        if(!data?.sendOTP){
            throw new Error(errors?.[0]?.message || 'Failed to send OTP');
          }
    
          return data;
        }catch(error: any){
          console.error('SendOTP Error:', {
            message: error.message,
            networkError: error.networkError,
            graphQLErrors: error.graphQLErrors,
          });
          throw error;
        }
    },
    async resendOTP(phone: string, entityType: string, transactionType: string): Promise<ResendOTPResponse> {
        try {
          console.log('Sending resendOTP request with:', { phone, entityType, transactionType });
          const { data } = await client.mutate({
            mutation: AUTH_QUERIES.RESEND_OTP,
            variables: { phone, entityType, transactionType },
          });
          return data;
        } catch (error: any) {
          console.error('ResendOTP Error:', {
            message: error.message,
            networkError: error.networkError,
            graphQLErrors: error.graphQLErrors,
            variables: { phone, entityType, transactionType }
          });
          throw error;
        }
      },
    
      async verifyPhoneOTP(
        phone: string,
        otp: string,
        transactionId: string,
        entityType: string,
      ): Promise<VerifyPhoneOTPResponse> {
        try {
          console.log('Sending verifyPhoneOTP request with:', { phone, otp, transactionId, entityType });
          
          // Get the token from AsyncStorage
          // const token = await AsyncStorage.getItem('@auth_token');
          // if (!token) {
          //   throw new Error('Authentication token not found. Please login again.');
          // }
    
          const { data , errors } = await client.mutate({
            mutation: AUTH_QUERIES.VERIFY_PHONE_OTP,
            variables: { phone, otp, transactionId, entityType },
            context: {
              headers: {
                // authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}`,
              },
            },
          });
    
          if(!data?.verifyPhoneOTP){
            throw new Error(errors?.[0]?.message || 'Failed to verify OTP');
          }
    
          return data;
        } catch (error: any) {
          console.error('VerifyPhoneOTP Error:', {
            message: error.message,
            networkError: error.networkError,
            graphQLErrors: error.graphQLErrors,
            variables: { phone, otp, transactionId, entityType }
          });
          throw error;
        }
      },
  }